import Client from '../HttpClient';

const baseUrl = '/gateway/numbat-api/api/vs/manage-menucloud';

const list = (merchantId, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/categorys`, payload);
};

const create = (merchantId, payload) => {
	return Client.post(`${baseUrl}/${merchantId}/categorys`, payload);
};

const find = (merchantId, id, payload) => {
	return Client.get(`${baseUrl}/${merchantId}/categorys/${id}`, payload);
};

const update = (merchantId, id, payload) => {
	return Client.put(`${baseUrl}/${merchantId}/categorys/${id}`, payload);
};

const remove = (merchantId, id, payload) => {
	return Client.del(`${baseUrl}/${merchantId}/categorys/${id}`, payload);
};

const menuGroup = (merchantId, menuGroupCode, payload) => {
	return Client.get(
		`${baseUrl}/${merchantId}/categorys/${menuGroupCode}/with-index`,
		payload
	);
};

const sort = (merchantId, payload) => {
	return Client.put(
		`${baseUrl}/${merchantId}/categoryMenuItem/arrange`,
		payload
	);
};

export default {
	list,
	find,
	create,
	update,
	remove,
	menuGroup,
	sort,
};
